var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCreditCard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 279 170",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".prefix__D{isolation:isolate}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258 0H21A21 21 0 000 21v128a21 21 0 0021 21h110.05c16.21-12 35.6-19 56.75-18.41 42.18 1.1 64.35-22.92 91.2-27.85V21a21 21 0 00-21-21z",
    fill: "#ededed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279 149v-25.26c-26.85 4.93-49 29-91.2 27.85-21.15-.59-40.54 6.41-56.75 18.41H258a21 21 0 0021-21z",
    fill: "#e2725b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.08 58.23a96 96 0 0154 11.2A108.24 108.24 0 00279 81.71V21a21 21 0 00-21-21H78.9c22.37 40.25 64.67 62 107.18 58.23z",
    fill: "#ddc8c4"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/creditCard.e2bf4a21.svg";
export { ForwardRef as ReactComponent };